import React from 'react';
import { BodyText, DataGrid, NavigationItem } from 'ui-toolkit';
import { IBootstrapTableColumnProps } from 'react-bootstrap-table-next';
import { formatPhoneNumber } from '../../utilities/shared/formatPhoneNumber';
import { eClientContactActionType } from '../../types/contacts/eClientContactActionType';
import { GetContactActionButton } from '../lenders/GetContactActionButton';
import { IClientUserData, IPresentationClientUserData } from '../../types/clients';
import { IContactFunctionData } from '../../types/contacts/IContactFunctionData';

interface IClientContactsTableProps {
  data: IClientUserData[];
  loading: boolean;

  onEditContact: (contact: IPresentationClientUserData) => void;
  setContactAction: (x: IUserAction | null) => void;
  contactFunctions: IContactFunctionData[];
}

export interface IUserAction {
  type: eClientContactActionType;
  user: IPresentationClientUserData;
}

export const ClientUsersTable: React.FC<IClientContactsTableProps> = ({
  data,
  loading,
  onEditContact,
  setContactAction,
  contactFunctions,
}) => {
  const columns: IBootstrapTableColumnProps[] = [
    {
      text: 'Function(s)',
      dataField: 'functions',
      sort: true,
      formatter: (cell: string[]) => {
        if (cell && cell.length > 1) {
          return 'Multiple';
        }
        if (cell && cell.length === 1) {
          const contactFunction = contactFunctions.find((func) => func.id === cell[0]);
          return contactFunction ? contactFunction.label : '';
        }
        return '';
      },
    },
    {
      text: 'Name',
      dataField: 'firstName',
      sort: true,
      formatter: (cell: string, row) => (
        <>
          {(row as IPresentationClientUserData).firstName} {(row as IPresentationClientUserData).lastName}
        </>
      ),
    },
    {
      text: 'Email',
      dataField: 'email',
      sort: true,
      formatter: (cell) => <NavigationItem href={`mailto:${cell}`} text={cell} isActive isInline />,
    },
    {
      text: 'Phone',
      dataField: 'phoneNumber',
      sort: true,
      formatter: (cell: string) => <>{formatPhoneNumber(cell || '')}</>,
    },
    {
      text: 'Company Name',
      dataField: 'companyName',
      sort: true,
    },
    {
      text: 'Notes',
      dataField: 'notes',
      sort: true,
      formatter: (cell) => <BodyText style={{ whiteSpace: 'pre-line' }}>{cell}</BodyText>,
    },
    {
      text: 'Options',
      dataField: 'id',
      formatter: (cell, row) => (
        <GetContactActionButton
          user={row as IPresentationClientUserData}
          setContactAction={(type) => setContactAction({ type, user: row as IPresentationClientUserData })}
          onEditContact={() => onEditContact(row as IPresentationClientUserData)}
        />
      ),
    },
  ];

  return (
    <>
      <DataGrid columns={columns} keyField={'key'} data={data} loading={loading} />
    </>
  );
};
